import {
    BarElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js"
import React, {useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {
    fillTopLabels
} from "../../../anwendungskonfigurator/content/widgets/stacked-barchart-widget/chart-utils"
import {Box} from "@mui/material"
import {buildStackedBarchartOptions, legendPositionMap} from "./stacked-barchart-options"

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
Chart.defaults.plugins.legend.display = false

export const detailStackedBarchartPrototype = [
    {
        key: "legend",
        type: "SELECT",
        label: "Legende",
        size: 6,
        options: [
            {value: "NONE", label: "Keine Legende"},
            {value: "BOTTOM", label: "Legende unten"},
            {value: "RIGHT", label: "Legende rechts"},
            {value: "PLACEHOLDER_BOTTOM", label: "Platzhalter unten"},
        ],
    },
    {
        key: "minHeight",
        type: "INTEGER",
        label: "Minimale Höhe",
        size: 3,
    },
]

const parseIntOrUndefined = (value) => {
    const parsed = parseInt(value, 10)
    return Number.isFinite(parsed) ? parsed : undefined
}

const DetailStackedBarchartWidget = ({widget, value}) => {
    const data = value
    const legendEntry =
        legendPositionMap[widget?.legend] ?? legendPositionMap.NONE
    const minHeight = parseIntOrUndefined(widget?.minHeight)

    const chartData = useMemo(
        () => ({
            labels: data?.bottomLabels ?? fillTopLabels(data),
            datasets: data?.datasets ?? [],
        }),
        [data],
    )

    return (
        <Box minHeight={minHeight ?? "inherit"}
             maxHeight="inherit"
             height="100%"
             minWidth="inherit"
             maxWidth="inherit">

        <Bar
            options={buildStackedBarchartOptions(data?.bottomLabels ?? [], legendEntry)}
            data={chartData}
        />

        </Box>
    )
}

export default DetailStackedBarchartWidget
